import React from 'react';
import Nabvar from '../Components/Navbar/Navbar'
import { Outlet } from 'react-router-dom';
import { useMediaQuery } from '@react-hook/media-query';
import Footer from '../Components/Footer/Footer'
import BtnWhatsapp from '../Components/BtnWhatsapp/BtnWhatsapp'
import Cart from '../Components/Cart/Cart'
import { DataProvider, useData } from '../Components/DataContext'
import EnConstruccion from '../Pages/EnConstruccion/EnConstruccion'
import { getTenantSlug } from '../Components/paths'

function PaginasContenido() {
    const { slugNoEncontrado } = useData();
    const isScreenLarge = useMediaQuery('(min-width: 900px)');

    if (slugNoEncontrado) return <EnConstruccion slug={getTenantSlug()} />;

    return (
        <div>
            {isScreenLarge ?
                <>
                    <Nabvar />
                    <Outlet />
                    <Footer />
                    <BtnWhatsapp />
                    <Cart />
                </> :
                <>
                    <Outlet />
                    <Footer />
                    <Cart />
                </>}

            <div className='espaciobg2'>

            </div>
        </div>
    );
}

export default function IndexLayout() {
    return (
        <DataProvider autoLoad={['bootstrap']}>
            <PaginasContenido />
        </DataProvider>
    );
}
